import ConfigApi from '@/api/config/_api_config'
import Api from '@/api/api'

export default {
    async summary(params = {}) {
        const access = await ConfigApi().post('/admin/finance-dashboard-access', {}, { admin_finance_access_request: true })
        const token = access.data && access.data.data && access.data.data.access_token
        if (!token) throw new Error('Accès au tableau Finances indisponible.')
        const response = await Api.comptabilite().get('/v1/finances/dashboard-summary', {
            params,
            headers: { 'X-Admin-Finance-Access': token },
            admin_finance_scoped: true
        })
        if (!response.data || !response.data.success) throw new Error('Indicateurs financiers indisponibles.')
        return response.data.data
    },
    async resume(periode = 'day') {
        const access = await ConfigApi().post('/admin/finance-dashboard-access', {}, { admin_finance_access_request: true })
        const token = access.data && access.data.data && access.data.data.access_token
        if (!token) throw new Error('Accès au tableau Finances indisponible.')
        const response = await Api.comptabilite().get('/admin/tableau-finances', {
            params: { periode },
            headers: { 'X-Admin-Finance-Access': token },
            admin_finance_scoped: true
        })
        if (!response.data || !response.data.success) throw new Error('Indicateurs financiers indisponibles.')
        return response.data.data
    }
}
